export const Days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type Days = typeof Days[number];
